var _radialGradient, _path, _linearGradient, _path2, _radialGradient2, _path3, _linearGradient2, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "9Y8YaPFEzyGwEgYZ1l__na",
    cx: -219.911,
    cy: -33.889,
    r: 25.29,
    gradientTransform: "rotate(-134.999 -86.009 -55.502)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#076cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#138cd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#199ae0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9Y8YaPFEzyGwEgYZ1l__na)",
    d: "M35.067,8.135L40,14.174v-9.54c0-0.528-0.639-0.792-1.013-0.419L35.067,8.135z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9Y8YaPFEzyGwEgYZ1l__nb",
    x1: 19.482,
    x2: 26.572,
    y1: 249.377,
    y2: 209.164,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9Y8YaPFEzyGwEgYZ1l__nb)",
    d: "M24,4C12.972,4,4,12.972,4,24s8.972,20,20,20c3.648,0,7.065-0.992,10.012-2.708c0.469-0.273,0.615-0.886,0.343-1.357l-1.492-2.584c-0.271-0.469-0.874-0.652-1.342-0.379C29.309,38.261,26.74,39,24,39c-8.271,0-15-6.729-15-15S15.729,9,24,9c2.909,0,5.612,0.851,7.91,2.293l-2.695,2.695C28.842,14.361,29.106,15,29.635,15h9.573C39.645,15,40,14.645,40,14.208v-2.157C36.349,7.175,30.546,4,24,4z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "9Y8YaPFEzyGwEgYZ1l__nc",
    cx: 36.693,
    cy: 38.778,
    r: 10.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9Y8YaPFEzyGwEgYZ1l__nc)",
    d: "M32.863,37.351c-0.271-0.469-0.874-0.652-1.342-0.379c-1.652,0.963-3.504,1.618-5.477,1.888c0.124,1.736,0.608,3.375,1.395,4.83c2.357-0.414,4.575-1.235,6.574-2.398c0.469-0.273,0.615-0.886,0.343-1.357L32.863,37.351z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9Y8YaPFEzyGwEgYZ1l__nd",
    x1: 30.929,
    x2: 45.071,
    y1: 223.071,
    y2: 208.929,
    gradientTransform: "matrix(1 0 0 -1 0 254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9Y8YaPFEzyGwEgYZ1l__nd)",
    d: "M48,38c0,5.522-4.478,10-10,10s-10-4.478-10-10s4.478-10,10-10S48,32.478,48,38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.646,42.354l-4-4c-0.195-0.195-0.195-0.512,0-0.707l0.707-0.707c0.195-0.195,0.512-0.195,0.707,0L37,39.879l5.439-5.439c0.195-0.195,0.512-0.195,0.707,0l0.707,0.707c0.195,0.195,0.195,0.512,0,0.707l-6.5,6.5C37.158,42.549,36.842,42.549,36.646,42.354z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.d630ccd7.svg";
export { ForwardRef as ReactComponent };